<template>
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title text-capitalize" id="modaltitle">
                {{ entry ? "Update" : "New" }} {{ type ? type.replace("_", " ") : "entry" }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div v-show="!confirmDelete" class="modal-body mx-3 px-2">
            <form>
                <div class="row" v-if="type === 'insurance_provider'">
                    <div class="col">
                        <label for="entryProvider">Provider</label>
                        <select
                            id="entryProvider"
                            class="form-control"
                            v-model="newEntry.provider_id"
                            :disabled="entry"
                        >
                            <option v-for="provider in availableProviders" :value="provider.id">{{
                                provider.name
                            }}</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-3" v-if="type === 'insurance_provider'">
                    <div class="col">
                        <label for="tradingPartnerId">Trading Partner ID </label>
                        <input
                            id="tradingPartnerId"
                            disabled="disabled"
                            type="text"
                            class="form-control"
                            :value="
                                helpers._get(
                                    availableProviders.find(
                                        provider => provider.id === newEntry.provider_id
                                    ),
                                    'pokitdok_trading_partner_id',
                                    ''
                                )
                            "
                        />
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <label for="entryName"
                            >Name
                            <i
                                v-if="type === 'insurance_provider'"
                                class="fa fa-info-circle text-info"
                                v-tooltip="`You can optionally customize the funding source name`"
                            ></i>
                        </label>
                        <input
                            id="entryName"
                            type="text"
                            class="form-control"
                            placeholder="Name"
                            v-model="newEntry.name"
                        />
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <label for="entryPrimaryPhone">Phone</label>
                        <input
                            id="entryPrimaryPhone"
                            v-mask="['(###) ###-#### ####']"
                            class="form-control"
                            placeholder="Phone"
                            v-model="newEntry.primary_phone"
                        />
                    </div>
                    <div class="col">
                        <label for="entryPrimaryFax">Fax</label>
                        <input
                            id="entryPrimaryFax"
                            v-mask="['(###) ###-#### ####']"
                            class="form-control"
                            placeholder="Fax"
                            v-model="newEntry.primary_fax"
                        />
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-6">
                        <label for="entryAddress">Address</label>
                        <input
                            id="entryAddress"
                            type="text"
                            class="form-control"
                            placeholder="Address"
                            v-model="newEntry.address1"
                        />
                    </div>
                    <div class="col-4">
                        <label for="entryCity">City</label>
                        <input
                            id="entryCity"
                            type="text"
                            class="form-control"
                            placeholder="City"
                            v-model="newEntry.city"
                        />
                    </div>
                    <div class="col-2">
                        <label for="entryState">State</label>
                        <input
                            id="entryState"
                            type="text"
                            class="form-control"
                            placeholder="State"
                            v-model="newEntry.state"
                        />
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <label for="entryAddress2">Address (line 2)</label>
                        <input
                            id="entryAddress2"
                            type="text"
                            class="form-control"
                            placeholder="Address (line 2)"
                            v-model="newEntry.address2"
                        />
                    </div>
                    <div class="col">
                        <label for="entryZip">Zip code</label>
                        <input
                            id="entryZip"
                            v-mask="['#####']"
                            class="form-control"
                            placeholder="Zip code"
                            v-model="newEntry.zip"
                        />
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-6">
                        <label for="entryMakeUpDays">Makeup days</label>
                        <input
                            id="entryMakeUpDays"
                            v-mask="['###']"
                            class="form-control"
                            placeholder="Makeup days"
                            v-model="newEntry.makeup_days"
                            v-if="!hideMakeUpDays"
                        />
                        <br v-if="hideMakeUpDays" />
                        <label for="withinTheMonth">
                            Within the month
                        </label>
                        <input
                            id="withinTheMonth"
                            type="checkbox"
                            @change="changeMakeupDays($event)"
                            v-model="hideMakeUpDays"
                        />
                    </div>
                    <div class="col" v-if="type === 'school'">
                        <label for="entryDistrict">District</label>
                        <input
                            id="entryDistrict"
                            type="text"
                            class="form-control"
                            placeholder="District"
                            v-model="newEntry.district"
                        />
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-3">
                        <p class="">Requires Supervision:</p>
                    </div>
                    <div class="col-9">
                        <select
                            v-if="therapistTypes.length"
                            class="form-control form-control-sm "
                            multiple
                            v-model="newEntry.requires_supervision_therapist_types"
                        >
                            <option v-for="t in therapistTypes" :value="t.title">{{
                                t.title
                            }}</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-3" v-if="type === 'insurance_provider'">
                    <div class="col">
                        <label for="entrySubmitClaimsBy">Submit claims by (days)</label>
                        <input
                            id="entrySubmitClaimsBy"
                            type="text"
                            class="form-control"
                            v-model="newEntry.claims_submit_by_days"
                            placeholder="Submit claims by (days)"
                        />
                    </div>
                    <div class="col">
                        <label for="entrySubmitAppealBy">Submit appeal by (days)</label>
                        <input
                            id="entrySubmitAppealBy"
                            type="text"
                            class="form-control"
                            v-model="newEntry.claims_appeal_by_days"
                            placeholder="Submit appeal by (days)"
                        />
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <div class="d-flex justify-content-end">
                            <a
                                id=""
                                v-show="editMode"
                                class="btn btn-sm btn-danger text-white font-weight-bold mx-3 text-uppercase"
                                @click="confirmDeleteEntry(true)"
                                style="min-width: 6rem;"
                                >Delete</a
                            >
                            <a
                                id="save-funding"
                                class="btn btn-sm btn-primary text-white font-weight-bold text-uppercase"
                                @click="editMode ? updateEntry() : saveEntry()"
                                style="min-width: 6rem;"
                                >Save</a
                            >
                        </div>
                    </div>
                </div>
                <errors :errors="errors"></errors>
            </form>
        </div>
        <div v-show="confirmDelete">
            <div class="p-3">
                <p>Are you sure you want to delete this entry?</p>
                <div class="d-flex justify-content-end mt-3">
                    <a
                        id="cancel-funding"
                        class="btn btn-sm btn-link text-primary font-weight-bold text-uppercase"
                        @click="confirmDeleteEntry(false)"
                        style="min-width: 6rem;"
                        >No, go back</a
                    >
                    <a
                        id="delete-funding"
                        class="btn btn-sm btn-danger text-white font-weight-bold mx-3 text-uppercase"
                        @click="deleteEntry()"
                        style="min-width: 6rem;"
                        >Yes, delete entry</a
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { helpers } from "../../plugins/helpers";
import { errors } from "../../plugins/errors";

export default {
    name: "NewEntry",
    props: ["type", "therapistTypes", "organizationId", "entry", "availableProviders"],
    mixins: [errors],
    data() {
        return {
            newEntry: {
                requires_supervision_therapist_types: [],
            },
            loading: false,
            editMode: false,
            hideMakeUpDays: false,
            confirmDelete: false,
        };
    },
    mounted() {
        $("#addEntry").on("hidden.bs.modal", () => {
            this.setErrors();
            this.resetNewEntry();
        });
    },
    watch: {
        "newEntry.provider_id"() {
            if (this.newEntry.provider_id) {
                const provider = this.availableProviders.find(
                    provider => provider.id === this.newEntry.provider_id
                );
                this.newEntry.name = provider.name;
            }
        },

        entry() {
            this.setErrors();
            if (this.entry) {
                this.editMode = true;
                this.hideMakeUpDays = false;
                this.newEntry = this.entry;
                if (this.newEntry.makeup_days === -1) {
                    this.hideMakeUpDays = true;
                }
            } else {
                this.editMode = false;
                this.resetNewEntry();
            }
        },
    },
    methods: {
        confirmDeleteEntry(state) {
            this.confirmDelete = state;
        },

        cleanNewEntry(newEntry) {
            if (newEntry.primary_phone) {
                newEntry.primary_phone = newEntry.primary_phone.replace(/-/g, "");
            }
            if (newEntry.primary_fax) {
                newEntry.primary_fax = newEntry.primary_fax.replace(/-/g, "");
            }
            return newEntry;
        },
        changeMakeupDays(event) {
            if (event.target.checked) {
                this.newEntry.makeup_days = -1;
            } else {
                delete this.newEntry.makeup_days;
            }
        },
        resetNewEntry() {
            this.confirmDelete = false;
            this.newEntry = {
                requires_supervision_therapist_types: [],
            };
        },
        deleteEntry() {
            this.setErrors();
            helpers.toggleSpinner("delete-funding");
            axios
                .delete(
                    `/api/organizations/${this.organizationId}/funding/sources/${this.newEntry.id}`
                )
                .then(r => {
                    this.newEntry = {
                        requires_supervision_therapist_types: [],
                    };
                    this.$emit("saved-source");
                    helpers.toggleSpinner("delete-funding");
                })
                .catch(e => {
                    console.error(e);
                    if (e.response && e.response.data) {
                        this.setErrors(_.get(e, "response.data.errors", {}));
                    }
                    helpers.toggleSpinner("delete-funding");
                });
        },
        saveEntry() {
            this.setErrors();
            helpers.toggleSpinner("save-funding", "Saving...");
            this.newEntry.type = this.type;
            this.newEntry = this.cleanNewEntry(this.newEntry);
            const payload = helpers.cleanEmptyProperties({ ...this.newEntry });
            axios
                .post(`/api/organizations/${this.organizationId}/funding/sources`, payload)
                .then(r => {
                    this.$emit("saved-source");
                    this.newEntry = {
                        requires_supervision_therapist_types: [],
                    };
                    this.confirmDelete = false;
                    helpers.toggleSpinner("save-funding");
                })
                .catch(e => {
                    console.error(e);
                    if (e.response && e.response.data) {
                        this.setErrors(_.get(e, "response.data.errors", {}));
                    }
                    this.confirmDelete = false;
                    helpers.toggleSpinner("save-funding");
                });
        },
        updateEntry() {
            this.setErrors();
            helpers.toggleSpinner("save-funding", "Saving...");
            this.newEntry.type = this.type;
            this.newEntry = this.cleanNewEntry(this.newEntry);
            let payload = helpers.cleanEmptyProperties({ ...this.newEntry });
            delete payload.expected_payments;
            axios
                .patch(
                    `/api/organizations/${this.organizationId}/funding/sources/${this.entry.id}`,
                    payload
                )
                .then(r => {
                    this.$emit("saved-source");
                    this.newEntry = {
                        requires_supervision_therapist_types: [],
                    };
                    this.editMode = false;
                    helpers.toggleSpinner("save-funding", "Saving...");
                })
                .catch(e => {
                    console.error(e);
                    if (e.response && e.response.data) {
                        this.setErrors(_.get(e, "response.data.errors", {}));
                    }
                    helpers.toggleSpinner("save-funding", "Saving...");
                });
        },
    },
};
</script>

<style scoped lang="scss"></style>
